import { Component, OnInit, Input } from '@angular/core';
import { DxColorBoxModule } from 'devextreme-angular';
import { TdoColorPickerEvent } from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import { DrawingToolsDefaults } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import {ConfigurationService} from '../configuration.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { MatSnackBar } from '@angular/material/snack-bar';

const ParamName = 'DEFAULT_DRAWING_TOOLS';

@Component({
  selector: 'app-drawing-tools',
  templateUrl: './drawing-tools.component.html',
  styleUrls: ['./drawing-tools.component.css']
})
export class DrawingToolsComponent implements OnInit {
  arrowHeadLength: number;
  useRatio: boolean;
  fillArrowhead: boolean;
  public drawParameter: cfgDrawParameter;
  public drawToolsDefaults: DrawingToolsDefaults;

  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.getDrawParameters(ParamName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (!this.drawParameter) {
          this.setDefaultValues();
          return;
        }
        this.drawToolsDefaults = JSON.parse(this.drawParameter.ParameterValue);
        this.arrowHeadLength = this.drawToolsDefaults.arrowLength;
        this.useRatio = this.drawToolsDefaults.useRatioArrowLen;
        this.fillArrowhead = this.drawToolsDefaults.fillArrowhead;

      }, err => {
         this.setDefaultValues();
      });

  }

  setDefaultValues() {
          this.arrowHeadLength = 50;
          this.useRatio = false;
          this.fillArrowhead = false;
          this.drawToolsDefaults = new DrawingToolsDefaults();
          this.drawToolsDefaults.arrowLength = this.arrowHeadLength;
          this.drawToolsDefaults.useRatioArrowLen = this.useRatio;
          this.drawToolsDefaults.fillArrowhead = this.fillArrowhead;
  }

  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }


  async onSave(e) {
    var drawParam = new DrawParameterObj();
    this.drawToolsDefaults.arrowLength = this.arrowHeadLength;
    this.drawToolsDefaults.useRatioArrowLen = this.useRatio;
    this.drawToolsDefaults.fillArrowhead = this.fillArrowhead;
    drawParam.parameterName = ParamName;
    const annDefaults = JSON.stringify(this.drawToolsDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults("00000000-0000-0000-0000-000000000000", drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }
}
